import {Component, Input} from '@angular/core';
import { Utils } from '../utils';

@Component({
    selector: 'sites-component',
    templateUrl: 'sites.component.html'
})
export class SitesComponent {
    @Input() sites;

    constructor(public utils: Utils) {}
}